import { FeatureFlagName } from "../../../mp-utils/generic-utils/feature-flags/types"
import { WidgetName } from "../../types"
import { WidgetDataProviderConfigType } from "./types"

export const WIDGET_DATA_PROVIDER_CONFIG: Partial<
  Record<WidgetName, WidgetDataProviderConfigType>
> = {
  AverageQuestionsAnswered: {
    dataSource: "graphql",
    graphqlFeatureFlag: FeatureFlagName.reporting_graphql_usage_student_widgets
  },
  AverageStudentTimeSpent: {
    dataSource: "graphql",
    graphqlFeatureFlag: FeatureFlagName.reporting_graphql_usage_student_widgets
  },
  AverageTestsCompleted: {
    dataSource: "graphql",
    graphqlFeatureFlag: FeatureFlagName.reporting_graphql_usage_student_widgets
  },
  ActiveStates: {
    dataSource: "graphql",
    fallbackDataSource: "legacyGraphql",
    graphqlFeatureFlag: FeatureFlagName.reporting_graphql_widget_active_states
  },
  ActiveOrganizations: {
    dataSource: "graphql",
    fallbackDataSource: "legacyGraphql",
    graphqlFeatureFlag:
      FeatureFlagName.reporting_graphql_widget_active_organizations
  },
  ActiveOrganizationAdmins: {
    dataSource: "graphql",
    fallbackDataSource: "legacyGraphql",
    graphqlFeatureFlag:
      FeatureFlagName.reporting_graphql_widget_active_organization_admins
  },
  ActiveDistrictAdmins: {
    dataSource: "graphql",
    fallbackDataSource: "legacyGraphql",
    graphqlFeatureFlag:
      FeatureFlagName.reporting_graphql_widget_active_district_admins
  },
  ActiveSchoolAdmins: {
    dataSource: "graphql",
    fallbackDataSource: "legacyGraphql",
    graphqlFeatureFlag:
      FeatureFlagName.reporting_graphql_widget_active_school_admins
  },
  ActiveStudents: {
    dataSource: "graphql",
    graphqlFeatureFlag: FeatureFlagName.reporting_graphql_widget_active_students
  },
  ActiveDistricts: {
    dataSource: "graphql",
    graphqlFeatureFlag:
      FeatureFlagName.reporting_graphql_widget_active_districts
  },
  ActiveSchools: {
    dataSource: "graphql",
    graphqlFeatureFlag: FeatureFlagName.reporting_graphql_widget_active_schools
  },
  ActiveTeachers: {
    dataSource: "graphql",
    graphqlFeatureFlag: FeatureFlagName.reporting_graphql_widget_active_teachers
  },
  ActiveClasses: {
    dataSource: "graphql",
    graphqlFeatureFlag: FeatureFlagName.reporting_graphql_widget_active_classes
  }
}
